import { Component, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../../services/auth.services'
import { SharedServices } from '../../../services/shared.services'
import { ModalService } from '../../../services/modal.service'
import { Router } from '@angular/router'
import { StateServices } from '../../../services/state.services'
import { Subject } from 'rxjs'

@Component({
    selector: 'app-layout-manager',
    templateUrl: './layout-app-element.component.html',
    styleUrls: [
        '../../../stagingcss/root-ui-view.component.css',
        '../../../stagingcss/main-body.component.css',
        '../../../stagingcss/main-view.component.css',
        '../../../stagingcss/lui-select.component.css',
        './layout-app-element.component.css',
    ],
})
export class LayoutAppElementComponent implements OnInit, OnDestroy {
    en = {}
    showEN = true
    arrayMenu = []
    statusSaveMail
    url
    changeObserver$ = new Subject<boolean>()

    constructor(private auth: AuthService, private router: Router, private _sharedService: SharedServices, private modalservice: ModalService, private stateServices: StateServices) {
        this.arrayMenu = this._sharedService.returnArrayMenu()
        const statusPath = this.router.url.includes('status')
        const settingPath = this.router.url.includes('setting')
        const clientPath = this.router.url.includes('client')
        const communicationPath = this.router.url.includes('communication')
        if (statusPath === true) {
            this.arrayMenu = this._sharedService.returnArraymenuleft('status')
        } else if (settingPath === true) {
            this.arrayMenu = this._sharedService.returnArraymenuleft('setting')
        } else if (clientPath === true) {
            this.arrayMenu = this._sharedService.returnArraymenuleft('client')
        } else if (communicationPath === true) {
            this.arrayMenu = this._sharedService.returnArraymenuleft('communication')
        }
        this._sharedService.changeEmitted$.takeUntil(this.changeObserver$).subscribe(
            success => {
                if (success) {
                    this.modalservice.emitChange(success)
                }
                if (success === 'activeAlertSaveMail') {
                    this.statusSaveMail = true
                }
                if (success === 'hiddenModalSaveMail') {
                    this.statusSaveMail = null
                }
            })
        this.en = this.auth.showLang(this.showEN)
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        if(this.changeObserver$){
            this.changeObserver$.next(true)
            this.changeObserver$.unsubscribe()
        }
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    checkSave(routesLink) {
        const arr = ['checkRotesLink', routesLink]
        this._sharedService.emitChange(arr)
    }

    onAction($event) {
        setTimeout(() => {
            $event.done()
            // this.items.push(0);
        }, 200)
    }

    changeOfRoutes() {
    }

    canDeactivate() {
        // return this.itunes.results.length > 0;
    }

    onChangeState($event) {
        // switch ($event.state) {
        //     case 'initial':
        //         this.message = 'Pull down to refresh';
        //         break;
        //     case 'preaction':
        //         this.message = 'Release to refresh';
        //         break;
        //     case 'action':
        //         this.message = 'Loading data...';
        //         break;
        // }
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/layout_app_element/layout-app-element.component.ts